import purchaseWeighUpModule from "./purchase-weigh-up-tasting";

export const purchaseWeighUpModules = {
  purchaseWeighUp: purchaseWeighUpModule,
};
